import { useTranslation as useTranslationNext } from 'react-i18next';
import config from '../../../package.json';

const { name } = config;

const useTranslation = (ns = name, props = {}) => useTranslationNext(ns, props);

export default useTranslation;
